<template>
  <div>
    <div class="mx-2 text-primary d-flex">
      <span class="mr-auto">
        <v-icon color="primary">mdi-map</v-icon>
        ({{ receptions.data.length }}) Domicilios de entrega
      </span>
      <v-btn
        v-if="receptions.data.length"
        class="ma-2"
        color="success"
        @click="exportExcel"
      >
        <v-icon size="15">mdi-file-excel</v-icon> Exportar</v-btn
      >
    </div>
    <v-simple-table dense class="main-table w-100">
      <template #default>
        <thead class="table-heading">
          <tr class="font-weight-bold">
            <th
              v-for="(header, index) in headers"
              :key="index"
              class="text-center text-dark font-weight-bold"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in receptions.data" :key="index">
            <td
              v-for="(item, index) in headers"
              :key="index"
              class="text-nowrap"
            >
              <template v-if="item.value === 'phone'">
                <a
                  v-if="row[item.value]"
                  :href="`tel:${row[item.value]}`"
                  class="text-decoration-none"
                >
                  <v-icon color="orange">mdi-phone</v-icon>
                  {{ formatPhone(row[item.value]) }}
                </a>
              </template>
              <template v-else-if="item.value === 'coordinates'">
                <a
                  v-if="row.coordinates?.latitude && row.coordinates?.longitude"
                  :href="`https://www.google.com/maps/search/?api=1&query=${row.coordinates?.latitude},${row.coordinates?.longitude}`"
                  target="_blank"
                  class="text-decoration-none"
                >
                  <v-icon color="blue">mdi-map-marker</v-icon> Ver mapa
                </a>
              </template>
              <template v-else-if="item.value === 'name'">
                {{ row[item.value] }} <br />
                <span class="subtitle-2 text-left">Horario de recepción:</span>
                <br />
                <v-tooltip
                  v-for="(item, index) in row.reception_hours"
                  :key="index"
                  bottom
                >
                  <template #activator="{ on, attrs }">
                    <span class="text-caption" v-bind="attrs" v-on="on">
                      {{ item.day }} |
                    </span>
                  </template>
                  <span>de {{ item.open }} a {{ item.close }}</span>
                </v-tooltip>
              </template>
              <template v-else> {{ row[item.value] }} </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
  import axios from '@/plugins/axios';
  import helpers from '@/mixins/helpers';
  import { useExcelExport } from '@/utilities/useExcelExport';

  export default {
    name: 'ReceptionsTable',
    mixins: [helpers],
    props: {
      customerId: {
        type: String,
        required: true,
      },
      customerChannel: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        receptions: {
          loading: false,
          data: [],
          error: false,
        },
        excelExport: useExcelExport(),
        headers: [
          {
            text: 'ID',
            value: 'id',
          },
          {
            text: 'Calle y número',
            value: 'street',
          },
          {
            text: 'colonia',
            value: 'colony',
          },
          {
            text: 'Estado',
            value: 'state',
          },
          {
            text: 'Código postal',
            value: 'postal_code',
          },
          {
            text: 'Telefono de contacto',
            value: 'phone',
          },
          {
            text: 'Encargado',
            value: 'name',
          },
          {
            text: 'Coordenadas',
            value: 'coordinates',
          },
        ],
        daysOfWeek: [
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
        ],
      };
    },
    mounted() {
      this.loadReceptions();
    },
    methods: {
      async exportExcel() {
        const receptionHours = this.daysOfWeek.map((day) => ({
          text: `Horario de ${day}`,
          value: `reception_${day}`,
        }));

        const headersWithCoordinates = [
          ...this.headers,
          ...receptionHours,
          {
            text: 'Latitud',
            value: 'coordinates.latitude',
          },
          {
            text: 'Longitud',
            value: 'coordinates.longitude',
          },
        ];

        const items = this.receptions.data.map((reception) => {
          const item = {
            ...reception,
          };

          this.daysOfWeek.forEach((day) => {
            const schedule = reception.reception_hours?.find(
              ({ day: receptionDay }) =>
                this.normalizeDay(receptionDay) === this.normalizeDay(day)
            );

            item[`reception_${day}`] = schedule
              ? `${schedule.open} - ${schedule.close}`
              : '';
          });

          return item;
        });

        await this.excelExport.exportExcel({
          headers: headersWithCoordinates,
          items,
          filename: 'Receptions.xlsx',
        });
      },
      normalizeDay(day) {
        return day
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      },
      async loadReceptions() {
        this.receptions.loading = true;
        try {
          const response = await axios.get(
            `v1/customer/receptions`,
            {
              params: {
                channel: this.customerChannel,
                customer_id: this.customerId,
              },
            },
            {
              cachable: true,
            }
          );
          this.receptions.data = response.data.data;
          this.receptions.error = false;
          this.$emit('receptionHasLoaded', this.receptions.data);
        } catch (error) {
          this.receptions.error = true;
        }
        this.receptions.loading = false;
      },
    },
  };
</script>
